import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Eye, Trophy, ArrowRight, ThumbsUp } from "lucide-react";
import { API } from "@/lib/api";
import { OverallScore } from "@/components/Scores";

export const useTopShared = (limit, period = "all") => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    setItems(null);
    axios.get(`${API}/shared/top`, { params: { limit, period } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [limit, period]);
  return items;
};

const medal = ["text-amber-300", "text-slate-300", "text-orange-400"];
const medalBorder = ["border-amber-500/50 shadow-[0_0_30px_rgba(245,158,11,0.12)]", "border-slate-300/40 shadow-[0_0_24px_rgba(203,213,225,0.08)]", "border-orange-500/40 shadow-[0_0_24px_rgba(217,119,6,0.1)]"];

export const RankRow = ({ item, rank, prefix = "rank", weekly = false }) => (
  <Link to={`/condivisa/${item.share_id}`} data-testid={`${prefix}-row-${rank}`}
    className={`group grid grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto_auto_auto] items-center gap-4 rounded-2xl border bg-[#12141F] px-5 py-4 transition-colors duration-200 hover:border-amber-500/40 ${medalBorder[rank - 1] || "border-white/[0.06]"}`}>
    <div className={`font-mono text-xl font-bold ${medal[rank - 1] || "text-slate-600"}`}>{rank <= 3 ? <Trophy className="w-6 h-6" data-testid={rank === 1 ? `${prefix}-winner-icon` : `${prefix}-medal-${rank}-icon`} /> : String(rank).padStart(2, "0")}</div>
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-slate-500">{item.categoria}</div>
      <div className="font-display font-semibold truncate group-hover:text-amber-300 transition-colors" data-testid={`${prefix}-name-${rank}`}>{item.nome}</div>
      <div className="text-sm text-slate-400 truncate hidden sm:block">{item.pitch}</div>
    </div>
    <div className="hidden sm:flex items-center gap-1.5 text-sm text-amber-200 font-mono" data-testid={`${prefix}-votes-${rank}`}><ThumbsUp className="w-4 h-4" /> {weekly ? item.weekly_votes : item.votes || 0}{weekly && <span className="text-[10px] text-slate-500 ml-1">7gg</span>}</div>
    <div className="hidden sm:flex items-center gap-1.5 text-sm text-slate-400 font-mono" data-testid={`${prefix}-views-${rank}`}><Eye className="w-4 h-4" /> {item.views}</div>
    <OverallScore value={item.punteggio_complessivo} testId={`${prefix}-score-${rank}`} />
  </Link>
);

export const TopShared = () => {
  const items = useTopShared(5);
  if (!items || items.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="top-shared-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 overline-label"><Trophy className="w-4 h-4" /> Classifica</div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold mt-3">Le idee condivise più viste.</h2>
        </div>
        <Link to="/classifica" data-testid="top-shared-all-link" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-amber-300 transition-colors">
          Vedi tutta la classifica <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="mt-8 space-y-3">{items.map((it, i) => <RankRow key={it.share_id} item={it} rank={i + 1} prefix="home-rank" />)}</div>
    </section>
  );
};
